import $ from 'jquery'
import {scrollToHash} from './categoryPage'
import {PGX_TEST_REQUISITION_FORM} from './constants'

const Physician = window.Physician || {}

// -------------------------------------
// order cart sidebar on physician pages
// -------------------------------------

function _isIOSDevice() {
  // query strings for iOS Safari device
  return navigator.userAgent.match(/iPad/i) != null || navigator.userAgent.match(/iPhone/i) != null
}

Physician.cart = {
  init: function() {
    // initial display of order count in cart
    var $sidebar = $('.catalog-sidebar')
    if (!_isIOSDevice() && $sidebar.length) {
      // scrolling cart for non-iOS browsers
      this.$sidebar = $sidebar
      this.onScroll = $.proxy(this.onScroll, this)
      this.onResize = $.proxy(this.onResize, this)
      var $container = this.$sidebar.closest('.container')
      $container.on('shown.bs.collapse', this.onScroll)
      $container.on('hidden.bs.collapse', this.onScroll)
      $(window).resize(this.onResize)
      $(window).scroll(this.onScroll)
      this.onResize()
    }
  },
  onResize: function() {
    var $parent = this.$sidebar.parent()
    this.$sidebar.outerWidth($parent.width())
    if (this.$sidebar.hasClass('fixed')) {
      var parentPadding = 15
      this.$sidebar.css('left', $parent.offset().left + parentPadding)
    }
    this.onScroll()
  },
  onScroll: function(e) {
    var winWidth = $(window).width()
    var $cart = this.$sidebar
    if (winWidth < 768) {
      return this.releaseCart($cart)
    }

    var $cartParent = $cart.closest('.row')

    var absolute = $cart.hasClass('absolute')
    var fixed = $cart.hasClass('fixed')

    var parent = {
      top: $cartParent.offset().top,
      height: $cartParent.height()
    }
    var scrollTop = $(window).scrollTop()
    var cartHeight = $cart.height()
    var limits = {
      top: parent.top - 115,
      bottom: parent.top + parent.height - cartHeight - 115
    }

    if (scrollTop > limits.bottom && !absolute) {
      if (fixed) {
        this.releaseCart($cart)
      }
      this.absCart($cart)
    } else if (scrollTop < limits.top && (fixed || absolute)) {
      this.releaseCart($cart)
    } else if (scrollTop > limits.top && scrollTop < limits.bottom && !fixed) {
      if (absolute) {
        this.releaseCart($cart)
      }
      this.fixCart($cart)
    }
  },
  releaseCart: function($cart) {
    $cart.removeClass('absolute')
    $cart.removeClass('fixed')
    $cart.css('left', 'auto')
    $cart.parent().css('height', 'auto')
  },
  absCart: function($cart) {
    $cart.css('left', $cart.position().left)
    $cart.parent().css('height', $cart.closest('.row').height())
    $cart.addClass('absolute')
  },
  fixCart: function($cart) {
    $cart.css('left', $cart.offset().left)
    $cart.addClass('fixed')
  }
}

function getAllSelectedGenes() {
  var checkedClass = 'icon-check-square'
  var genes = []
  $('.test-selection').each(function(index) {
    var $checkbox = $(this).find('.icon')
    if ($checkbox.hasClass(checkedClass)) {
      genes = [...genes, ...Physician.customize.getRealGenesList($(this))]
    }
  })
  return genes
}

Physician.customize = {
  init: function() {
    Physician.customize.prepareOrder()
    var $orderGroups = $('.order-groups-list')
    var checkedClass = 'icon-check-square'
    var uncheckedClass = 'icon-square'

    $('#add-to-order').click(function() {
      var data = $(this).data()
      if (data.id) {
        Physician.order.toggleCart(this)
      }
      const genes = getAllSelectedGenes()
      window.Common.Amplitude.trackTestPanelAddedToOrder({
        testName: $('#concept-name')
          .text()
          .trim(),
        siteLocation: 'Tests Panel',
        genesCount: genes.length,
        genes: genes,
        customPanel: data.primaryExcluded
      })
    })

    $('.package-item .add-to-order-button').click(function() {
      var data = $(this).data()
      if (data.id) {
        Physician.order.toggleCart(this)
      }
    })

    $('#order-now').on('click', function() {
      const data = $(this).data()
      if (data.isPgx) {
        window.open(PGX_TEST_REQUISITION_FORM, '_blank')
      }
    })

    if ($orderGroups.children().size() > 1) {
      selectOrderGroup($.cookie('selectedOrderGroup'))
    }
    $orderGroups.on('click', '.order-group-checkbox', function() {
      var $this = $(this)
      var $checkbox = $this.find('.icon')
      if ($checkbox.hasClass(checkedClass)) {
        deselectOrderGroup($this.data().orderGroupCode)
      } else {
        $orderGroups
          .find('.icon')
          .removeClass(checkedClass)
          .addClass(uncheckedClass)
        selectOrderGroup($this.data().orderGroupCode)
      }
    })

    function deselectOrderGroup(groupCode) {
      $('.gene-add-button').addClass('disabled-order-group-gene')
      $('.order-group-' + groupCode + ' .icon')
        .addClass(uncheckedClass)
        .removeClass(checkedClass)
    }

    function selectOrderGroup(groupCode) {
      $('.gene-add-button').addClass('disabled-order-group-gene')
      if (groupCode) {
        $('.group-code-' + groupCode + ' .gene-add-button').removeClass('disabled-order-group-gene')
        $('.order-group-' + groupCode + ' .icon')
          .addClass(checkedClass)
          .removeClass(uncheckedClass)
        $.cookie('selectedOrderGroup', groupCode)
      }
    }

    // if a test is clicked
    $('.toggle-default, .toggle-custom').on('click', function() {
      const obj = $(this).closest('.test-selection')
      const isDiagnosticRNA = !!$(this).closest('[data-product-type=Diagnostic+RNA]').length

      // if the clicked test is already selected
      if ($(this).hasClass('checked')) {
        // We should prevent unselecting panels or add-ons for RNA orders because they are required - WT-16265
        if (!isDiagnosticRNA) {
          Physician.customize.resetTest($(this))
        }
      } else {
        // reset already selected tests that are not available for co-adding
        const oneOfGroups = this.className.match(/one_of_\d+/g)
        if (oneOfGroups) {
          var tests = $('.toggle-default, .toggle-custom').not(this)
          $.each(tests, function(key, value) {
            var test = $(this)
            oneOfGroups.forEach(function(group) {
              if (test.hasClass('checked') && test.hasClass(group)) {
                Physician.customize.resetTest(test)
              }
            })
          })
        }

        // reset the tests
        Physician.customize.uncheckTest(obj.find('.toggle-default, .toggle-custom'))
        obj.find('.gene').removeClass('excluded')
        Physician.customize.updateGeneCounts(obj)
        obj.find('.toggle-default').show()
        obj.find('.toggle-custom').hide()

        // select the test
        Physician.customize.checkTest($(this))
        obj.addClass('selected')
        if ($(this).hasClass('toggle-custom')) {
          obj.find('.toggle-default').hide()
        }
      }

      // EDGE CASE HACK FOR TEST
      var defaultTest = $('.primary-test.toggle-default')
      var customTest = $('.primary-test.toggle-custom')
      if (
        $(this).hasClass('optional-test') &&
        $(this).hasClass('toggle-default') &&
        $(this).hasClass('checked') &&
        !defaultTest.hasClass('checked') &&
        !customTest.hasClass('checked')
      ) {
        // if this is an optional default test AND the primary default test or primary custom test IS NOT selected, also select the primary default test
        defaultTest.closest('.test-selection').addClass('selected')
        Physician.customize.checkTest(defaultTest)
      } else if (
        $(this).hasClass('optional-test') &&
        $(this).hasClass('toggle-default') &&
        $(this).hasClass('checked') &&
        !defaultTest.hasClass('checked') &&
        customTest.hasClass('checked')
      ) {
        // if this is an optional default test AND the primary custom test IS selected, switch this to an optional custom test
        Physician.customize.uncheckTest(obj.find('.toggle-default'))
        Physician.customize.checkTest(obj.find('.toggle-custom'))
        Physician.customize.updateGeneCounts(obj)
        obj.find('.toggle-default').hide()
        obj.find('.toggle-custom').show()
      }

      // EDGE CASE HACK FOR TEST
      // if primary default test is deselected, switch all selected optional default tests to optional custom tests
      if ($(this).hasClass('primary-test') && !obj.hasClass('selected')) {
        // change optional test default
        var optionalDefaultTests = $('.optional-test.toggle-default')
        $.each(optionalDefaultTests, function(key, value) {
          var optionalTest = $(this)
          if (optionalTest.hasClass('checked')) {
            var tempObj = optionalTest.closest('.test-selection')

            Physician.customize.uncheckTest(optionalTest)
            if (optionalTest.hasClass('nips-panel')) {
              tempObj.find('.gene').addClass('excluded')
              Physician.customize.updateGeneCounts(tempObj)
              //Selecting optional nips panel w/o primary is not avail
              return
            }
            tempObj.find('.toggle-default').hide()

            Physician.customize.checkTest(tempObj.find('.toggle-custom'))
            tempObj.find('.toggle-custom').show()

            tempObj.find('.gene').removeClass('excluded')
            Physician.customize.updateGeneCounts(tempObj)
          }
        })
        // for nips panels also reset optional custom tests
        var nipsOptionalCustomTests = $('.optional-test.toggle-custom.nips-panel')
        $.each(nipsOptionalCustomTests, function(key, value) {
          var nipsOptionalTest = $(this)
          if (nipsOptionalTest.hasClass('checked')) {
            Physician.customize.resetTest(nipsOptionalTest)
          }
        })
      }

      // EDGE CASE HACK - FOR TEST
      // if primary default test is selected, switch all selected optional custom tests which are fully selected to optional default tests
      else if ($(this).hasClass('primary-test') && obj.hasClass('selected')) {
        var optionalCustomTests = $('.optional-test.toggle-custom')
        $.each(optionalCustomTests, function(key, value) {
          var optionalTest = $(this)
          if (optionalTest.hasClass('checked') && optionalTest.closest('.selected').find('.excluded').length == 0) {
            Physician.customize.uncheckTest(optionalTest)
            var tempObj = optionalTest.closest('.test-selection')
            Physician.customize.checkTest(tempObj.find('.toggle-default'))
            tempObj.find('.toggle-custom').hide()
            tempObj.find('.toggle-default').show()
            Physician.customize.updateGeneCounts(tempObj)
          }
        })
      }
      Physician.customize.prepareOrder()
    })

    // if a gene is clicked
    $('.gene').on('click', function() {
      const $gene = $(this)
      const isLocked = $gene.hasClass('non-removable')
      const obj = $gene.closest('.test-selection')
      const lockedGenesContainer = obj.find('p.locked')
      const isPreventive = !!$('[data-product-type=Preventive]').length
      const isStatTat = !!$('[data-product-type=STAT-TAT]').length
      const isExomeSlice = !!$('[data-product-type="Exome Slice"]').length
      if (isLocked && $gene.closest('[data-product-type=Diagnostic]').length === 0) {
        // If user trying to select one of the required gene - select whole list of required genes (WHCP-300)
        if (isLocked && !obj.hasClass('selected')) {
          const lockedGenesLength = obj.find('.non-removable').length
          const allGenesLength = obj.find('.gene').length
          obj.find('.gene').addClass('excluded')
          Physician.customize.uncheckTest(obj.find('.toggle-default'))
          obj.find('.non-removable.gene').toggleClass('excluded')
          if (allGenesLength === lockedGenesLength) {
            Physician.customize.checkTest(obj.find('.toggle-default'))
          } else {
            obj.find('.toggle-default').hide()
            obj.find('.toggle-custom').show()
            Physician.customize.checkTest(obj.find('.toggle-custom'))
          }
          Physician.customize.updateGeneCounts(obj)
          obj.addClass('selected')
          Physician.customize.prepareOrder()
          return
        }
        if (isStatTat) {
          $('#stat-tat-gene-modal').modal('show')
        } else if (isPreventive) {
          $('#preventive-fixed-gene-modal').modal('show')
        } else if (isExomeSlice) {
          $('#exome-slice-gene-modal').modal('show')
        }
        return
      }
      // can customize if test has more than one gene
      if (obj.find('.gene').length != 1) {
        // if the test is already selected
        if (obj.hasClass('selected')) {
          $gene.toggleClass('excluded')
          // all genes are excluded
          if (obj.find('.excluded').length == obj.find('.gene').length) {
            // reset all
            Physician.customize.uncheckTest(obj.find('.toggle-default, .toggle-custom'))
            obj.find('.toggle-default').show()
            obj.find('.toggle-custom').hide()
            obj.find('.gene').removeClass('excluded')
            Physician.customize.updateGeneCounts(obj)
            obj.removeClass('selected')
          }
          // all genes are included
          else if (obj.find('.excluded').length == 0) {
            // reset all
            obj.find('.toggle-default').show()
            Physician.customize.checkTest(obj.find('.toggle-default'))
            obj.find('.toggle-custom').hide()
            Physician.customize.uncheckTest(obj.find('.toggle-custom'))
            obj.addClass('selected')
          } else {
            // some genes are excluded
            obj.find('.toggle-default').hide()
            Physician.customize.uncheckTest(obj.find('.toggle-default'))
            obj.find('.toggle-custom').show()
            Physician.customize.checkTest(obj.find('.toggle-custom'))
            Physician.customize.updateGeneCounts(obj)
            obj.addClass('selected')
          }
        } else {
          // if the test has not been selected
          obj.addClass('selected')
          obj.find('.gene').addClass('excluded')
          $gene.toggleClass('excluded')
          obj.find('.toggle-default').hide()
          Physician.customize.uncheckTest(obj.find('.toggle-default'))
          obj.find('.toggle-custom').show()
          // If user select optional gene when there are required list of genes - select them (WHCP-300)
          if (lockedGenesContainer.length > 0) {
            obj.find('.non-removable.gene').toggleClass('excluded')
          }
          Physician.customize.checkTest(obj.find('.toggle-custom'))
          Physician.customize.updateGeneCounts(obj)
          obj.addClass('selected')
        }

        // EDGE CASE HACK - FOR GENE
        var defaultTest = $('.primary-test.toggle-default')

        if (!defaultTest.hasClass('checked')) {
          if (defaultTest.hasClass('nips-panel')) {
            defaultTest.closest('.test-selection').addClass('selected')
            Physician.customize.checkTest(defaultTest)
          }
          // if primary default test is deselected, switch any optional default tests to optional custom tests
          var optionalDefaultTests = $('.optional-test.toggle-default')
          $.each(optionalDefaultTests, function(key, value) {
            if ($(optionalDefaultTests[key]).hasClass('checked')) {
              Physician.customize.uncheckTest($(optionalDefaultTests[key]))
              var tempObj = $(optionalDefaultTests[key]).closest('.test-selection')
              Physician.customize.checkTest(tempObj.find('.toggle-custom'))
              tempObj.find('.toggle-default').hide()
              tempObj.find('.toggle-custom').show()
              Physician.customize.updateGeneCounts(tempObj)
            }
          })
        } else if (defaultTest.hasClass('checked')) {
          // if primary default test is selected, switch any optional custom tests to optional default tests
          var optionalCustomTests = $('.optional-test.toggle-custom')
          $.each(optionalCustomTests, function(key, value) {
            if (
              $(optionalCustomTests[key]).hasClass('checked') &&
              $(optionalCustomTests[key])
                .closest('.selected')
                .find('.excluded').length === 0
            ) {
              Physician.customize.uncheckTest($(optionalCustomTests[key]))
              var tempObj = $(optionalCustomTests[key]).closest('.test-selection')
              Physician.customize.checkTest(tempObj.find('.toggle-default'))
              tempObj.find('.toggle-custom').hide()
              tempObj.find('.toggle-default').show()
              Physician.customize.updateGeneCounts(tempObj)
            }
          })
        }
        Physician.customize.prepareOrder()
      }
    })
  },
  checkTest: function(obj) {
    $(obj)
      .addClass('checked')
      .find('span.icon')
      .addClass('icon-check-square')
      .removeClass('icon-square')
  },
  uncheckTest: function(obj) {
    $(obj)
      .removeClass('checked')
      .find('span.icon')
      .removeClass('icon-check-square')
      .addClass('icon-square')
  },
  resetTest: function(obj) {
    Physician.customize.uncheckTest(obj)
    var testData = $(obj).closest('.test-selection')
    testData.find('.gene').removeClass('excluded')
    testData.removeClass('selected')
    testData.find('.toggle-default').show()
    testData.find('.toggle-custom').hide()
  },
  updateGeneCounts: function(obj) {
    const genesCount = Physician.customize.getRealGenesListCount(obj)
    const excludedGenesCount = Physician.customize.getExcludedRealGenesListCount(obj)
    obj
      .find('.toggle-custom')
      .find('.genes-included-count')
      .text(genesCount - excludedGenesCount)
    obj
      .find('.toggle-custom')
      .find('.genes-excluded-count')
      .text(excludedGenesCount)
  },
  getRealGenesListCount: function($panel) {
    return Physician.customize.getRealGenesCountBySelector($panel, '.gene')
  },
  getRealGenesList: function($panel) {
    return Physician.customize.getRealGenesBySelector($panel, '.gene')
  },
  getExcludedRealGenesListCount: function($panel) {
    return Physician.customize.getRealGenesCountBySelector($panel, '.excluded')
  },

  getRealGenesBySelector: function($panel, selector) {
    const listOfExcludedGeneNames = $panel
      .find(selector)
      .map((index, item) => item.innerHTML)
      .toArray()
    return listOfExcludedGeneNames.reduce((acc, item) => {
      const gene = item.split(', ')
      return acc.concat(gene)
    }, [])
  },

  getRealGenesCountBySelector: function($panel, selector) {
    return Physician.customize.getRealGenesBySelector($panel, selector).length
  },

  getFakeOptInData: function(tests) {
    let fakeOptInCode = ''
    let isFakeOptInSelected = false
    let isFakeOptInExcluded = false
    if (tests.length > 1) {
      const fakeOptInPostfix = 'fake_opt_in'
      const testCode = tests
        .eq(1)
        .find('.toggle-default')
        .find('.icon')
        .data('id')
      fakeOptInCode = testCode.indexOf(fakeOptInPostfix) === -1 ? '' : testCode
      if (fakeOptInCode) {
        const fakePanel = tests.eq(1)
        isFakeOptInSelected = fakePanel.hasClass('selected')
        isFakeOptInExcluded = !!(isFakeOptInSelected && fakePanel.find('.gene.excluded').length)
      }
    }

    return {
      fakeOptInCode,
      hasFakeOptIn: !!fakeOptInCode,
      isFakeOptInSelected,
      isFakeOptInExcluded
    }
  },

  prepareOrder: function() {
    // collect codes and copy into submit button data-id
    var tests = $('.test-selection')
    var data_codes = []
    var primaryExcluded = false
    var optionalIncluded = false

    // check if primary is checked and has excluded genes
    var primary = tests.eq(0)
    const isPrimarySelected = primary.hasClass('selected')
    if (isPrimarySelected && primary.find('.gene.excluded').length) {
      primaryExcluded = true
    }

    // check if optional is checked and has included genes
    var optional = tests.slice(1)
    if (optional.hasClass('selected')) {
      optionalIncluded = true
    }

    // get fake opt in data
    const {hasFakeOptIn, isFakeOptInExcluded, isFakeOptInSelected} = this.getFakeOptInData(tests)
    const shouldPushOnlyGenes =
      hasFakeOptIn && (isFakeOptInExcluded || !isFakeOptInSelected) && isPrimarySelected && !primaryExcluded

    // collecting test and optional genes id
    $.each(tests, function(testIndex, test) {
      var $test = $(test)

      const testCode = $test
        .find('.toggle-default')
        .find('.icon')
        .data('id')
      const defaultPanelChecked = $test.find('.toggle-default').hasClass('checked')

      if (defaultPanelChecked && !shouldPushOnlyGenes) {
        data_codes.push(testCode)
      } else if ($test.find('.toggle-custom').hasClass('checked') || (defaultPanelChecked && shouldPushOnlyGenes)) {
        var genes = $test.find('.gene')
        $.each(genes, function(geneKey, gene) {
          var $gene = $(gene)
          if (!$gene.hasClass('excluded')) {
            data_codes.push($gene.data('id'))
          }
        })
      }
    })
    $('#add-to-order').data({
      primaryExcluded: primaryExcluded,
      optionalIncluded: optionalIncluded,
      id: data_codes.toString()
    })
  }
}

Physician.alphabetNavigation = {
  init: function() {
    var $letterIndex = $('.letter-index')
    if (_isIOSDevice() || !$letterIndex.length) {
      return
    }
    this.$letterIndex = $letterIndex
    this.$letterIndexContainer = $letterIndex.parent()
    // scrolling alphabet navigation for non-iOS browsers
    $(window)
      .on('scroll', $.proxy(this.windowScroll, this))
      .on('resize', $.proxy(this.windowResize, this))
    this.windowScroll()
  },
  windowResize: function() {
    this.$letterIndex.css('left', 'auto').removeClass('fixed')
    this.windowScroll()
  },
  windowScroll: function() {
    var li = this.$letterIndex.filter(':visible')
    if (!li.length) {
      return
    }
    if (this.$letterIndexContainer.offset().top - $(window).scrollTop() < 88) {
      li.addClass('fixed')
      li.css({
        left: this.$letterIndexContainer.offset().left,
        width: this.$letterIndexContainer.width()
      })
      li.closest('section').css('min-height', '475px')
    } else {
      li.removeClass('fixed')
      li.css('left', 'auto')
      li.closest('section').css('min-height', 'auto')
    }
  }
}

Physician.expandSubCategories = {
  init: function() {
    if ($('#category-tests').data('expand-first-category') === 'True') {
      var $firstPanel = $('.category-panel:first')
      $firstPanel.find('.category-header').removeClass('collapsed')
      $firstPanel.find('.category-content').addClass('in')
    }
  }
}

$(function() {
  Physician.cart.init()
  Physician.customize.init()
  Physician.alphabetNavigation.init()
  Physician.expandSubCategories.init()
  scrollToHash()
})
